import { useState } from "react";
import { Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

const PROFESSIONS = [
  { value: "tecnico", label: "Tecnico / Geometra" },
  { value: "architetto", label: "Architetto / Progettista" },
  { value: "impresa", label: "Impresa edile" },
  { value: "finanziario", label: "Consulente finanziario / Mutui" },
  { value: "legale", label: "Notaio / Studio legale" },
  { value: "altro", label: "Altro" },
];

export default function PartnerForm({ onSubmitted }) {
  const [form, setForm] = useState({ name: "", profession: "", phone: "", email: "", city: "", website: "", message: "" });
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (sending) return;
    setSending(true);
    try {
      await api.post("/partners", form);
      toast.success("Richiesta ricevuta.", {
        description: "La direzione A.C. HUB esaminerà il tuo profilo e ti ricontatterà.",
      });
      setForm({ name: "", profession: "", phone: "", email: "", city: "", website: "", message: "" });
      onSubmitted && onSubmitted();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="partner-form" className="grid gap-4">
      <div className="grid gap-4 sm:grid-cols-2">
        <input
          className="field"
          placeholder="Nome / Studio *"
          value={form.name}
          onChange={set("name")}
          required
          minLength={2}
          data-testid="partner-name-input"
        />
        <select className="field" value={form.profession} onChange={set("profession")} data-testid="partner-profession-select">
          <option value="">La tua professione…</option>
          {PROFESSIONS.map((p) => (
            <option key={p.value} value={p.value}>{p.label}</option>
          ))}
        </select>
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <input
          className="field"
          placeholder="Telefono *"
          type="tel"
          value={form.phone}
          onChange={set("phone")}
          required
          minLength={8}
          data-testid="partner-phone-input"
        />
        <input
          className="field"
          placeholder="Email (facoltativa)"
          type="email"
          value={form.email}
          onChange={set("email")}
          data-testid="partner-email-input"
        />
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <input
          className="field"
          placeholder="Città / Area di lavoro"
          value={form.city}
          onChange={set("city")}
          data-testid="partner-city-input"
        />
        <input
          className="field"
          placeholder="Sito o profilo Instagram"
          value={form.website}
          onChange={set("website")}
          data-testid="partner-website-input"
        />
      </div>
      <textarea
        className="field min-h-[92px] resize-y"
        placeholder="In due righe: cosa fai e con quali clienti lavori…"
        value={form.message}
        onChange={set("message")}
        data-testid="partner-message-input"
      />
      <button type="submit" data-testid="partner-submit-button" disabled={sending} className="btn btn-gold w-full disabled:opacity-60">
        {sending ? <Loader2 size={15} className="animate-spin" /> : <Check size={15} />}
        {sending ? "Invio in corso…" : "Chiedi di entrare nella rete"}
      </button>
    </form>
  );
}
